<template>
    <span>{{ display }}</span>
</template>

<script>
export default {
    name: 'DateHandler',

    props: {
        date: String,
    },

    computed: {
        display() {
            if (this.date) {
                const dateValue = new Date(this.date)
                const Y = dateValue.getFullYear()
                const m =
                    dateValue.getMonth() + 1 < 10
                        ? `0${(dateValue.getMonth() + 1).toString()}`
                        : (dateValue.getMonth() + 1).toString()
                const d =
                    dateValue.getDate() < 10
                        ? `0${dateValue.getDate().toString()}`
                        : dateValue.getDate().toString()
                return `${d}/${m}/${Y}`
            }

            return '-'
        },
    },
}
</script>
